import './index.scss';
import React, {PropTypes} from 'react';
import WarrantyDatePicker from '../../../../shared/components/warranty-date-picker';
import moment from 'moment';

export default class WarrantyAgGridDatePicker extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            date: null,
            pickerDate: null
        };

    }

    componentDidUpdate(prevState) {

        if (prevState.date !== this.state.date) {

            this.props.onDateChanged();

        }

    }

    getDate() {

        return this.state.date;

    }

    setDate(inputDate) {

        let pickerDate;

        if (inputDate) {

            if (inputDate.getTimezoneOffset() > 0) {

                inputDate.setDate(inputDate.getDate() + 1);

            }

            pickerDate = moment(inputDate);
            pickerDate.add(pickerDate.utcOffset(), 'minutes').utc();

        } else {

            pickerDate = null;

        }

        this.handleDateChange(pickerDate);

    }

    handleDateChange(pickerDate) {

        this.setState({
            date: pickerDate ? pickerDate.toDate() : null,
            pickerDate
        });

    }

    render() {

        return (

            <div className='ag-grid-date-picker'>
                <WarrantyDatePicker
                    onChange={this.handleDateChange.bind(this)}
                    selected={this.state.pickerDate}
                />
            </div>

        );

    }

}

WarrantyAgGridDatePicker.displayName = 'WarrantyAgGridDatePicker';
WarrantyAgGridDatePicker.propTypes = {
    onDateChanged: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/reports/shared/components/ag-grid-date-picker/index.js